<template>
    <div @click="pullApp()">请使用浏览器打开</div>
</template>

<script>
export default {
    data: function() {
        return {

        };
    },
    mounted() {
        this.pullApp();
    },
}
</script>